import { Skeleton } from 'primereact/skeleton';

export function LoadingState({ label = 'Loading products' }: { label?: string }) {
  return (
    <div className="loading-state" role="status" aria-label={label}>
      <span className="visually-hidden">{label}</span>
      {[1, 2, 3].map((item) => (
        <div className="loading-card" key={item}>
          <Skeleton height="14rem" />
          <Skeleton width="45%" className="loading-card__line" />
          <Skeleton width="80%" />
        </div>
      ))}
    </div>
  );
}
